import MoreDetailsSidebar from './MoreDetailsSidebar';

export default MoreDetailsSidebar;